// — если в названии одно слово берем первые три буквы
// —  если два слова - берем 2 буквы от первого слова и одно от второго
// — если три и больше - берем по букве из каждого слова, но не более трех

export const shortenTeamName = (teamName: string) => {
  const words = teamName.split(' ');
  if (words.length === 1) {
    return teamName.slice(0, 3).toUpperCase();
  }
  if (words.length === 2) {
    return words[0].slice(0, 2).toUpperCase() + words[1].slice(0, 1).toUpperCase();
  }
  if (words.length >= 3) {
    return words[0].slice(0, 1).toUpperCase() + words[1].slice(0, 1).toUpperCase() + words[2].slice(0, 1).toUpperCase();
  }
};
